import React, { } from 'react';
import { Box } from "@material-ui/core"
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useStyles } from '../styles/index.style';

const TableFilters = ({
   filters, 
   onFilterChange
}) => {
   const classes = useStyles();

   return (
      <Box display="flex" justifyContent="flex-start" flexWrap="wrap" style={{ background: "#e5e5e5"}} >
         <Box display="flex" className={classes.tableFiltersFlex} pb="15px" py="18px" alignItems="center">
            <Box style={{ marginLeft: 15, marginRight: 10 }}>
               Filter by Date
            </Box>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
               <DatePicker
                  variant="inline"
                  inputVariant="outlined"
                  label="From"
                  value={filters.fromDate}
                  style={{ paddingRight: 20 }}
                  onChange={(date) => onFilterChange({fromDate: moment(date).format("YYYY-MM-DD")})}
                  aria-label="from date picker"
                  InputProps={{
                     style: {
                       backgroundColor: 'white'
                     }
                   }}
                 
               />
               <DatePicker
                  variant="inline"
                  inputVariant="outlined"
                  label="To"
                  value={filters.toDate}
                  style={{ paddingRight: 20 }}
                  onChange={(date) => onFilterChange({toDate: moment(date).format("YYYY-MM-DD")})}
                  InputProps={{
                     style: {
                       backgroundColor: 'white'
                     }
                   }}
               />
            </MuiPickersUtilsProvider>
         </Box>
      </Box>
   )
}

TableFilters.propTypes = {
   filters: PropTypes.shape({
      fromDate: PropTypes.string,
      toDate: PropTypes.string,
      searchTerm: PropTypes.string,
   }),
   onFilterChange: PropTypes.func,
};

TableFilters.defaultProps = {
   filters: {fromDate: null, toDate: null, searchTerm: null,},
   onFilterChange: null,
};

export default TableFilters